import { keywordType, orderType } from './type';

export const keywordList: keywordType[] = [
  '청결도',
  '비흡연',
  '흡연',
  '아침형',
  '저녁형',
  '잠버릇',
  '애주가',
];

export const orderList: orderType[] = [
  '등록일 순',
  '일치율 높은 순',
  '모집마감 임박 순',
  '저장 많은 순',
];
